/** Characters that make a spreadsheet treat a cell as a formula (CSV injection). */
const FORMULA_PREFIXES = ["=", "+", "-", "@"];

/**
 * Quote a field only when it would otherwise break the row, and collapse embedded
 * newlines — matching `exportChartCsv` so a file opened side-by-side parses identically.
 */
export function escapeCsvField(value: string): string {
  const clean = value.replace(/[\n\r]/g, " ").trim();
  if (!clean.includes('"') && !clean.includes(",") && !clean.includes("\n")) return clean;
  return `"${clean.replace(/"/g, '""')}"`;
}

/**
 * Prefix formula-leading text so Excel/Sheets does not execute it. Numeric cells
 * skip this — a legitimate `-40` must stay a number, not `'-40`.
 */
export function textCell(value: string): string {
  const clean = value.replace(/[\n\r]/g, " ").trim();
  const guarded = FORMULA_PREFIXES.some((prefix) => clean.startsWith(prefix))
    ? `'${clean}`
    : clean;
  return escapeCsvField(guarded);
}
